// extracted by mini-css-extract-plugin
export const slidesContainer = "slidesContainer-module--slidesContainer--1L4iF";